<template>
  <div style="margin-top:30px;">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="标题"
              prop="title"
              style="margin-right:15px"
            >
              <el-input
                v-model.trim="form.title"
                placeholder="请输入"
                @change="(value)=>{form.title = value.replace(/\s/g,'')}"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="内容"
              prop="content"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.content"
                type="textarea"
                :rows="3"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          v-if="form.type=='PTYS'"
          :span="24"
        >
          <div class="grid-content bg-purple">
            <el-form-item
              label="序号"
              prop="idx"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.idx"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="类型"
              prop="type"
              style="margin-right:15px"
            >
              <el-select
                v-model="form.type"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="(v,k) in dicts.siteDeploy"
                  :key="k"
                  :label="v"
                  :value="k"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col
          v-if="form.type=='PTYS' || form.status=='1'"
          :span="12"
        >
          <div class="grid-content bg-purple">
            <el-form-item
              label="序号"
              prop="idx"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.idx"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="是否导航"
              prop="status"
              style="margin-right:15px"
            >
              <el-select
                v-model="form.status"
                clearable
                placeholder="请选择"
              >
              <el-option value="0" label="否"></el-option>
              <el-option value="1" label="是"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          v-if="form.status=='1'"
          :span="12"
        >
          <div class="grid-content bg-purple">
            <el-form-item
              label="内路链接"
              prop="links"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.links"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20" v-if="form.status=='1'">
          <div class="grid-content bg-purple">
            <el-form-item
              label="上级目录"
              prop="parentCode"
              style="margin-right:15px"
            >
             <el-cascader :options="options"
             v-model="form.parentCode"
             :emitPath="false"
             :props="{ checkStrictly: true }"
             @change="handerChange"
             ></el-cascader>

            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24"  v-if="form.type=='PTYS' || form.status=='1'">
          <div class="grid-content bg-purple">
            <el-form-item
              label="图片"
              style="margin-right:15px"
              :required="false"
            >
              <ImgUpload
                :upload-config="{ lebal: '门户图片', prefix: 'img', form, suffix: '', modal: false }"
                :parent-data="{ isDetail: false }"
                :required="false"

              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"   v-if="form.type=='PTYS' || form.status=='1'">
          <div class="grid-content bg-purple">
            <el-form-item
              label="图片"
              style="margin-right:15px"
              :required="false"
            >
              <ImgUpload
                :upload-config="{ lebal: '导航图标图片', prefix: 'url', form, suffix: '', modal: false }"
                :parent-data="{ isDetail: false }"
                :required= "false"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import ImgUpload from "@/components/ImgUpload";
  
  export default {
    name: 'SiteDeployEdit',
    components: {
      ImgUpload
    },
    data() {
      return {
        options:[],
        dicts: { siteDeploy: {}},
        emptyForm: {},
        form: {
          code: '',
          branchCode: '',
          links: '',
          parentCode: '0',
          title: '',
          content: '',
          idx:'',
          img: '',
          type: '',
          url: '',
          status: ''
        },
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' },
            { min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur' }
          ],
          content: [
            { min: 1, max: 1000, message: '长度在 1 到 1000 个字符', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择类型', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      // 保存空表单对象
      this.emptyForm = JSON.parse(JSON.stringify(this.form))
      
    },
    methods: {
         //级联选择
    handerChange(val){
      console.log(val)
      this.form.parentCode=val[val.length - 1]
      console.log(this.form.parentCode)
    },
      // 获取页面信息
      getInfo(code, dicts,options) {
        this.dicts = dicts
        this.options = options
        // 查询到数据之前先展示空表单
        this.form = JSON.parse(JSON.stringify(this.emptyForm))
        this.$refs["form"].resetFields()
        request({ url: `/ntocc-basic-api/siteDeploy/${code}`, method: 'get' }).then(response => {
          this.form = response.data
          this.form.status =response.data.status+''
        })
      },
      // 提交
      funcSubmit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const data = this.form
            const rLoading = this.openLoading();
            request({ url: '/ntocc-basic-api/siteDeploy', method: 'put', params: data }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: 'success' })
              this.$emit('fatherEditMethod')
            })
          } else {
            return false
          }
        })
      },
      // 取消
      funcCancel() {
        this.$emit('fatherCancelMethod', 'edit')
      }
    }
  }
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
</style>
